import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Space, Select, Divider } from 'antd';
import { Tag } from 'antd';
import { categoricalFilters } from './screensConfig';

const CategoricalFilters = ({ securityType, onFilterChange, filters }) => {
  const tickerCategories = useSelector(state => state.global.cache.sectorsIndustries);
  const [selectedValues, setSelectedValues] = useState({});

  // Get available filters from config
  const getAvailableFilters = () => {
    const filters = categoricalFilters[securityType] || {};
    return Object.entries(filters).map(([key, config]) => ({
      key,
      label: config.label
    }));
  };

  // Update local state when external filters change
  useEffect(() => {
    const newSelectedValues = {};
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (key.startsWith('tags.')) {
        const actualKey = key.replace('tags.', '');
        newSelectedValues[actualKey] = value.value;
      }
    });
    setSelectedValues(newSelectedValues);
  }, [filters]);

  const handleFilterChange = (filterKey, value) => {
    if (value && value.length > 0) {
      onFilterChange(`tags.${filterKey}`, 'in', value, true);
    } else {
      onFilterChange(`tags.${filterKey}`, null, null, false);
    }
  };

  return (
    <Space direction="vertical" className="w-full p-4">
      {getAvailableFilters().map(({ key, label }) => (
        <div key={key} className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {label}
          </label>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder={`Select ${label}`}
            value={selectedValues[key] || []}
            onChange={(value) => handleFilterChange(key, value)}
            options={
              tickerCategories?.[key]?.map(item => ({
                label: item,
                value: item,
              })) || []
            }
          />
        </div>
      ))}
    </Space>
  );
};

export default CategoricalFilters;